import React from 'react'
import { useHistory } from 'react-router'
import { Profile2User, ProfileCircle } from 'iconsax-react'
import { useTheme } from '@mui/material'

import { useUserAPI } from '@SonarCX/providers/UserAPIProvider'
import { Routes } from '@SonarCX/Routes'
import { FavoriteCardProps } from '..'

import Tooltip from '@SonarCX/components/atoms/Tooltip'
import DraggableContainer from '../DraggableContainer'
import FavoriteButton from '@SonarCX/components/atoms/FavoriteButton'

import useStyles from '../styles'

const FavoriteUser: React.FC<FavoriteCardProps> = ({
  favorite,
  filter,
  searchValue,
  draggable,
  handleMoveFavorite
}) => {
  const theme = useTheme()
  const classes = useStyles({})
  const history = useHistory()
  const { allUsers, loadUser } = useUserAPI()
  const hasUserFilter = filter === 'Contacts' || filter === 'Team'
  const user = React.useMemo(
    () => allUsers[favorite.item_id] ?? null,
    [allUsers, favorite]
  )

  const navigate = () => {
    history.push(
      `${user?.type?.external ? Routes.CUSTOMERS : Routes.USERS}/${
        favorite.item_id
      }`
    )
  }
  // Load concerning user if needed
  React.useEffect(() => {
    if (!user) {
      loadUser(favorite.item_id)
    }
  }, [user, loadUser, favorite])

  if (!user) return null

  if (hasUserFilter && filter === 'Contacts' && !user.type.external) return null
  if (hasUserFilter && filter === 'Team' && user.type.external) return null

  if (
    searchValue.length > 0 &&
    !user.name.toLowerCase().includes(searchValue.toLowerCase())
  )
    return null

  const icon = user.type.external ? (
    <ProfileCircle
      size={theme.size.base}
      variant='Bulk'
      color={theme.palette.primary.main}
    />
  ) : (
    <Profile2User
      size={theme.size.base}
      variant='Bulk'
      color={theme.palette.primary.main}
    />
  )

  return (
    <DraggableContainer
      favorite={favorite}
      draggable={draggable}
      handleMoveFavorite={handleMoveFavorite}
    >
      <div onClick={navigate}>
        <span className={classes.info}>
          <FavoriteButton
            isFavorite
            type={favorite.type}
            itemId={favorite.item_id}
          />

          <Tooltip title={user.type.external ? 'Contact' : 'Team'}>
            {icon}
          </Tooltip>
          <span className={classes.title}> {user.name} </span>
        </span>
      </div>
    </DraggableContainer>
  )
}

export default FavoriteUser
